<aside
  class="fixed left-0 top-[var(--banner-offset,0px)] z-[9999] flex h-[var(--layout-escolhido)] flex-col bg-primario-500 pb-4 transition-all duration-300"
  [ngClass]="isSidebarOpen ? 'w-3/12 xs:w-10/12 sm:w-8/12 md:w-4/12 xl:w-2/12 2xl:w-2/12' : 'w-[6rem] xs:w-2/12'"
  *ngIf="isLoggedUser"
>

  <!-- ── Header: logo + toggle ── -->
  <div class="flex w-full flex-col items-center justify-center px-3 pt-4">
    <app-logo [isToggle]="isSidebarOpen" routerLink="/home" class="cursor-pointer"></app-logo>

    <div class="mt-4 flex w-full flex-row items-center gap-4" [ngClass]="isSidebarOpen ? 'justify-between' : 'justify-center'">
      <hr class="w-full border-primario-700" />
      <button
        [title]="isSidebarOpen ? 'Fechar' : 'Expandir'"
        type="button"
        (click)="handleSidebar()"
        class="flex h-8 w-8 cursor-pointer flex-row items-center justify-center rounded-full bg-primario-700 text-branco hover:opacity-90"
      >
        <span class="material-icons flex w-5/12 items-center justify-center text-xl"
              [ngClass]="isSidebarOpen ? '-scale-x-100' : 'scale-x-100'">chevron_left</span>
        <span class="material-icons flex w-5/12 items-center justify-center text-xl"
              [ngClass]="isSidebarOpen ? '-scale-x-100' : 'scale-x-100'">chevron_right</span>
      </button>
      <hr class="w-full border-primario-700" />
    </div>
  </div>

  <!-- ── Busca (só quando expandido) ── -->
  <div class="mt-4 px-3 mb-3" *ngIf="isSidebarOpen">
    <div class="flex items-center gap-2 rounded-lg bg-primario-700/40 px-3 py-2 transition focus-within:bg-primario-700/70">
      <span class="material-icons text-base text-gray-400">search</span>
      <input
        placeholder="Pesquisar no menu..."
        type="text"
        class="w-full bg-transparent text-sm text-primario-50 placeholder-gray-400 outline-none"
        [(ngModel)]="textSearch"
        id="pesquisar-menu"
        name="pesquisar-menu"
        autocomplete="off"
      />
    </div>
  </div>

  <!-- ── Nav expandida ── -->
  <nav
    *ngIf="isSidebarOpen"
    class="flex-1 overflow-y-auto px-3 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-600"
  >
    <div class="flex flex-col gap-y-1 pb-4">
      <ng-container *ngFor="let option of filteredRoutes">

        <!-- Item simples com rota -->
        <a
          *ngIf="!option.hasSubtopics && !option.hasTopics && option.routeName"
          [id]="option.id"
          [routerLink]="option.routeName"
          routerLinkActive="sidebar-item-active"
          #rlaMain="routerLinkActive"
          (click)="handleClickModule(null)"
          class="sidebar-item flex items-center gap-x-3 rounded-lg px-4 py-2.5 text-base font-medium text-gray-300 transition-all duration-150 hover:bg-white/10 hover:text-white"
          [ngClass]="rlaMain.isActive ? 'sidebar-item-active' : ''"
        >
          <span class="material-icons text-xl">{{ option.iconName }}</span>
          <span class="truncate">{{ option.moduleName }}</span>
        </a>

        <!-- Item simples sem rota (em breve) -->
        <div
          *ngIf="!option.hasSubtopics && !option.hasTopics && !option.routeName"
          class="flex cursor-default items-center justify-between rounded-lg px-4 py-2.5 text-base font-medium text-gray-500"
        >
          <div class="flex items-center gap-x-3">
            <span class="material-icons text-xl">{{ option.iconName }}</span>
            <span class="truncate">{{ option.moduleName }}</span>
          </div>
          <span class="text-xs italic text-gray-600">em breve</span>
        </div>

        <!-- Grupo nível 1 com subtópicos diretos -->
        <mat-accordion *ngIf="option.hasSubtopics && !option.hasTopics && option.isVisible">
          <mat-expansion-panel
            class="panel-custom-arrow"
            [expanded]="textSearch ? option.isOpen : option.moduleName === selectedModule"
            [id]="option.id"
          >
            <mat-expansion-panel-header (click)="handleClickModule(option.moduleName)" class="sidebar-item-expandable">
              <mat-panel-title>
                <span class="material-icons text-xl menu-icon">{{ option.iconName }}</span>
                <span class="ml-3 truncate text-base font-medium menu-text">{{ option.moduleName }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="mt-1 flex flex-col gap-y-0.5">
              <ng-container *ngFor="let subtopic of option.subtopics">
                <a
                  *ngIf="subtopic.isVisible && subtopic.routeName"
                  [id]="subtopic.id"
                  [routerLink]="subtopic.routeName"
                  routerLinkActive="sidebar-subitem-active"
                  #rla="routerLinkActive"
                  class="sidebar-subitem flex items-center gap-x-2 rounded-lg py-2 pl-5 pr-3 text-base text-gray-400 transition-all duration-150 hover:bg-white/10 hover:text-white"
                  [ngClass]="rla.isActive ? 'sidebar-subitem-active' : ''"
                >
                  <span class="text-[8px]" [ngClass]="rla.isActive ? 'text-blue-400' : 'text-gray-600'">●</span>
                  <span class="truncate">{{ subtopic.name }}</span>
                </a>
                <div
                  *ngIf="subtopic.isVisible && !subtopic.routeName"
                  class="flex cursor-default items-center justify-between rounded-lg py-2 pl-5 pr-3 text-base text-gray-600"
                >
                  <span class="truncate">{{ subtopic.name }}</span>
                  <span class="text-xs italic">em breve</span>
                </div>
              </ng-container>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- Grupo nível 1 com topics (ex: Administração) -->
        <mat-accordion *ngIf="option.hasTopics && option.isVisible">
          <mat-expansion-panel
            class="panel-custom-arrow"
            [expanded]="textSearch ? option.isOpen : option.moduleName === selectedModule"
            [id]="option.id"
          >
            <mat-expansion-panel-header (click)="handleClickModule(option.moduleName)" class="sidebar-item-expandable">
              <mat-panel-title>
                <span class="material-icons text-xl menu-icon">{{ option.iconName }}</span>
                <span class="ml-3 truncate text-base font-medium menu-text">{{ option.moduleName }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <!-- Topics como expansion panels nível 2 -->
            <div class="mt-1 flex flex-col gap-y-0.5">
              <mat-accordion *ngFor="let topic of option.topics">
                <mat-expansion-panel
                  *ngIf="topic.isVisible"
                  class="panel-custom-arrow panel-nested"
                  [expanded]="textSearch ? topic.isOpen : option.moduleName === selectedModule && topic.moduleName === selectedSubModule"
                  [id]="topic.id"
                >
                  <mat-expansion-panel-header
                    (click)="handleClickSubModule(topic.moduleName)"
                    class="sidebar-topic-expandable"
                  >
                    <mat-panel-title>
                      <span class="ml-1 truncate text-base font-medium menu-topic-text">{{ topic.moduleName }}</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <div class="mt-0.5 flex flex-col gap-y-0.5">
                    <ng-container *ngFor="let subtopic of topic.subtopics">
                      <a
                        *ngIf="subtopic.isVisible && subtopic.routeName"
                        [id]="subtopic.id"
                        [routerLink]="subtopic.routeName"
                        routerLinkActive="sidebar-subitem-active"
                        #rla="routerLinkActive"
                        class="sidebar-subitem flex items-center gap-x-2 rounded-lg py-2 pl-8 pr-3 text-base text-gray-400 transition-all duration-150 hover:bg-white/10 hover:text-white"
                        [ngClass]="rla.isActive ? 'sidebar-subitem-active' : ''"
                      >
                        <span class="text-[8px]" [ngClass]="rla.isActive ? 'text-blue-400' : 'text-gray-600'">●</span>
                        <span class="truncate">{{ subtopic.name }}</span>
                      </a>
                      <div
                        *ngIf="subtopic.isVisible && !subtopic.routeName"
                        class="flex cursor-default items-center justify-between rounded-lg py-2 pl-8 pr-3 text-base text-gray-600"
                      >
                        <span class="truncate">{{ subtopic.name }}</span>
                        <span class="text-xs italic">em breve</span>
                      </div>
                    </ng-container>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

      </ng-container>
    </div>
  </nav>

  <!-- ── Nav recolhida: ícones + versão (layout antigo) ── -->
  <ul *ngIf="!isSidebarOpen" class="h-full">
    <div class="h-[80%]">
      <li
        class="flyout-item my-4 flex cursor-pointer items-center justify-center rounded p-3 text-primario-50 transition-all duration-150 hover:bg-primario-300"
        *ngFor="let option of routes"
        (click)="handleIconSidebar(option)"
        (mouseenter)="onIconMouseEnter($event)"
      >
        <span class="material-icons">{{ option.iconName }}</span>

        <div class="flyout-panel" [style.top.px]="flyoutTop">
          <div class="flyout-header">{{ option.moduleName }}</div>

          <ng-container *ngIf="!option.hasSubtopics && !option.hasTopics && option.routeName">
            <div [routerLink]="option.routeName" (click)="$event.stopPropagation()" class="flyout-link" routerLinkActive="flyout-link-active">
              {{ option.moduleName }}
            </div>
          </ng-container>

          <ng-container *ngIf="option.hasSubtopics && !option.hasTopics">
            <ng-container *ngFor="let subtopic of option.subtopics">
              <div
                *ngIf="subtopic.isVisible && subtopic.routeName"
                [routerLink]="subtopic.routeName"
                (click)="$event.stopPropagation()"
                class="flyout-link"
                routerLinkActive="flyout-link-active"
              >
                <span class="flyout-dot"></span>
                {{ subtopic.name }}
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="option.hasTopics">
            <ng-container *ngFor="let topic of option.topics">
              <ng-container *ngIf="topic.isVisible">
                <div class="flyout-topic-header">{{ topic.moduleName }}</div>
                <ng-container *ngFor="let subtopic of topic.subtopics">
                  <div
                    *ngIf="subtopic.isVisible && subtopic.routeName"
                    [routerLink]="subtopic.routeName"
                    (click)="$event.stopPropagation()"
                    class="flyout-link flyout-link-indented"
                    routerLinkActive="flyout-link-active"
                  >
                    <span class="flyout-dot"></span>
                    {{ subtopic.name }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </li>
    </div>
    <div class="flex h-[20%] items-end pb-4">
      <h3
        (click)="handleOpenVersion()"
        class="w-full cursor-pointer rounded-xl p-3 text-base text-primario-50 hover:bg-primario-300"
      >
        {{ version }}
      </h3>
    </div>
  </ul>

  <!-- ── Footer versão (só expandido) ── -->
  <div class="mt-auto border-t border-primario-700 px-3 pt-3" *ngIf="isSidebarOpen">
    <div
      (click)="handleOpenVersion()"
      class="flex cursor-pointer flex-col rounded-lg px-3 py-2 text-gray-500 transition hover:bg-white/10"
    >
      <span class="text-xs">IDUS - SRA ©</span>
      <span class="text-xs">Versão {{ version }}</span>
    </div>
  </div>

</aside>
